export const _en = {
    addButton: {
        label: "Add time vacation"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        add: {
            title: "Add a time vacation",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    }
};


export const _fr = {
    addButton: {
        label: "Vacation"
    },
    toggleDeleted: {
        label: "Afficher les vacations archivées"
    },
    dialog: {
        add: {
            title: "Ajouter une vacation",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    }
};